import { BaseModel } from '../../area-zucchetti/model/area-zucchetti.model';
import { AreaResource, AreaType } from '../../area.resource';

export class AreaFusionResource extends AreaResource {
   public static readonly TYPE =  AreaType.fusion;

   type_user: UserOfAfTypeResource;
   url: string;
   buyer: boolean;
   requester: boolean;
   approver: boolean;
   approval_power: number;
   approval_power_cost_centers: string;
   notes: string;


   society: SocietyResource[] | string;
   user_profile:UserProfileResource | string;
   belonging_offices:BelongingOfficesResource | string;

  constructor() {
    super(AreaFusionResource.TYPE);
  }
}

export class UserOfAfTypeResource {
  id: string;
  type: string;
  links:string[];
}



export class BaseResource{
  links:any[];
  id: number;
  value:string;
  description:string;

  setJson(json:BaseModel){
    this.id = json.id;
    this.value = json.value;
    this.description = json.description;
    this.links = json.links;
  }
}

export class UserProfileResource extends BaseResource{}
export class BelongingOfficesResource  extends BaseResource{}
export class SocietyResource extends BaseResource{}